import { appConfig as $config } from '@App/app.config';

let notificationFileByResolution = (data, printAreas) => {
  let notificationStatus = { isAreaFull: false, isAreaOptimal: false, isAreaPocket: false };

  let DPI = $config.filesModel[1].DPI;

  let values =
    data.reader && data.reader.width
      ? data.reader
      : data.additionalValues && data.additionalValues.width && data.additionalValues.height
      ? data.additionalValues
      : false;

  if (!values) return { isAreaFull: true, isAreaOptimal: true, isAreaPocket: true };

  if (
    values.width * 1 >= printAreas.$printAreaFull.width * DPI ||
    values.height * 1 >= printAreas.$printAreaFull.height * DPI
  )
    notificationStatus.isAreaFull = true;
  if (
    values.width * 1 >= printAreas.$printAreaOptimal.width * DPI ||
    values.height * 1 >= printAreas.$printAreaOptimal.height * DPI
  )
    notificationStatus.isAreaOptimal = true;
  if (
    values.width * 1 >= printAreas.$printAreaPocket.width * DPI ||
    values.height * 1 >= printAreas.$printAreaPocket.height * DPI
  )
    notificationStatus.isAreaPocket = true;

  return notificationStatus;
};

export const suitabilityRender = (full, printAreas) => {
  let out = '';
  let fileModel = $config.filesModel[full.type];
  let fileExtension = full.name.split('.').pop();

  if (
    fileModel &&
    fileModel.showSuitability &&
    fileExtension &&
    fileModel.suitabilityViewExtensions.includes(fileExtension)
  ) {
    out = `<span class="text-success">${$lang.assetsManager.notifications.Allcanvassizes}</span>`;
    let arr = [],
      status = notificationFileByResolution(full, printAreas);
    if (!status.isAreaFull) arr.push($Lang.assetsManager.notifications.fullarea);
    if (!status.isAreaOptimal) arr.push($Lang.assetsManager.notifications.optimalarea);
    if (!status.isAreaPocket) arr.push($Lang.assetsManager.notifications.pocketarea);
    if (arr.length) {
      out = `<span class="text-danger">${
        $Lang.assetsManager.notifications.doesnt + arr.join(', ') + $Lang.assetsManager.notifications.canvassize
      }</span>`;
    }
  }
  return out;
};

export const pantoneNameRender = (data, type, full, $infoMode) => {
  return $infoMode
    ? data
    : `<input type="text" name="pantoneName" data-id="${full.id}" value="${data}" class="form-control js-action-onplaceedit">`;
};

export const colorPalleteRender = (data, type, full, $infoMode) => {
  return $infoMode
    ? `${data.Cyan} - ${data.Magenta} - ${data.Yellow} - ${data.Key}`
    : `<div class="d-flex">
       <input type="number" placeholder="C" data-id="${full.id}" name="Cyan" min="0" max="100" step="1" value="${data.Cyan}" class="form-control js-action-onplaceedit js-max-number-100">
       <input type="number" placeholder="M" data-id="${full.id}" name="Magenta" min="0" max="100" step="1" value="${data.Magenta}" class="form-control js-action-onplaceedit js-max-number-100">
       <input type="number" placeholder="Y" data-id="${full.id}" name="Yellow" min="0" max="100" step="1" value="${data.Yellow}" class="form-control js-action-onplaceedit js-max-number-100">
       <input type="number" placeholder="K" data-id="${full.id}" name="Key" min="0" max="100" step="1" value="${data.Key}" class="form-control js-action-onplaceedit js-max-number-100">
     </div>`;
};
